'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/discount/Circle.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DiscountCircleIcon = (props) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "21",
      viewBox: "0 0 20 21",
      fill: "none"
    }, props), {
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.0001 3.55534C6.31818 3.55534 3.33341 6.54011 3.33341 10.222C3.33341 13.9039 6.31818 16.8887 10.0001 16.8887C13.682 16.8887 16.6667 13.9039 16.6667 10.222C16.6667 6.54011 13.682 3.55534 10.0001 3.55534ZM1.66675 10.222C1.66675 5.61963 5.39771 1.88867 10.0001 1.88867C14.6025 1.88867 18.3334 5.61963 18.3334 10.222C18.3334 14.8244 14.6025 18.5553 10.0001 18.5553C5.39771 18.5553 1.66675 14.8244 1.66675 10.222ZM6.07749 12.9661L12.7442 6.29942L13.9227 7.47793L7.256 14.1446L6.07749 12.9661Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M7.91658 7.72233C7.91658 7.95245 7.73004 8.139 7.49992 8.139C7.2698 8.139 7.08325 7.95245 7.08325 7.72233C7.08325 7.49221 7.2698 7.30566 7.49992 7.30566C7.73004 7.30566 7.91658 7.49221 7.91658 7.72233Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.54159 7.72233C8.54159 8.29763 8.07522 8.764 7.49992 8.764C6.92462 8.764 6.45825 8.29763 6.45825 7.72233C6.45825 7.14703 6.92462 6.68066 7.49992 6.68066C8.07522 6.68066 8.54159 7.14703 8.54159 7.72233ZM7.49992 8.139C7.73004 8.139 7.91659 7.95245 7.91659 7.72233C7.91659 7.49221 7.73004 7.30566 7.49992 7.30566C7.2698 7.30566 7.08325 7.49221 7.08325 7.72233C7.08325 7.95245 7.2698 8.139 7.49992 8.139Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12.9166 12.7223C12.9166 12.9524 12.73 13.139 12.4999 13.139C12.2698 13.139 12.0833 12.9524 12.0833 12.7223C12.0833 12.4922 12.2698 12.3057 12.4999 12.3057C12.73 12.3057 12.9166 12.4922 12.9166 12.7223Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.5416 12.7223C13.5416 13.2976 13.0752 13.764 12.4999 13.764C11.9246 13.764 11.4583 13.2976 11.4583 12.7223C11.4583 12.147 11.9246 11.6807 12.4999 11.6807C13.0752 11.6807 13.5416 12.147 13.5416 12.7223ZM12.4999 13.139C12.73 13.139 12.9166 12.9524 12.9166 12.7223C12.9166 12.4922 12.73 12.3057 12.4999 12.3057C12.2698 12.3057 12.0833 12.4922 12.0833 12.7223C12.0833 12.9524 12.2698 13.139 12.4999 13.139Z",
            fill: "currentColor"
          }
        )
      ]
    })
  );
};

// src/discount/DiscountIcon.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var DiscountIcon = (props) => {
  return /* @__PURE__ */ jsxs2(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx2(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 2.00006H20V22.4983L16.7344 20.2591L14.3333 22.3171L12 20.3171L9.66667 22.3171L7.26556 20.2591L4 22.4983V2.00006ZM6 4.00006V18.7018L7.4011 17.7411L9.66667 19.683L12 17.683L14.3333 19.683L16.5989 17.7411L18 18.7018V4.00006H6Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 8.00006C7.75 7.30971 8.30964 6.75006 9 6.75006C9.69036 6.75006 10.25 7.30971 10.25 8.00006C10.25 8.69042 9.69036 9.25006 9 9.25006C8.30964 9.25006 7.75 8.69042 7.75 8.00006Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.75 14.0001C13.75 13.3097 14.3096 12.7501 15 12.7501C15.6904 12.7501 16.25 13.3097 16.25 14.0001C16.25 14.6904 15.6904 15.2501 15 15.2501C14.3096 15.2501 13.75 14.6904 13.75 14.0001Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.6642 7.75006L9.45712 14.9572L8.04291 13.543L15.25 6.33585L16.6642 7.75006Z",
            fill: "currentColor"
          }
        )
      ]
    })
  );
};

export {
  DiscountCircleIcon,
  DiscountIcon
};
//# sourceMappingURL=chunk-BFXFSKJG.mjs.map